<template>
  <nav v-if="pages > 1" class="text-center">
    <ul class="pagination justify-content-center">
      <li class="page-item" :class="{ disabled: page <= 1 || disabled }">
        <a class="page-link" role="button" @click="setPage(page - 1)">&lt;</a>
      </li>
      <li v-for="p in visiblePages" :key="p" class="page-item" :class="{ active: p === page }">
        <a class="page-link" role="button" @click="setPage(p)">{{ p }}</a>
      </li>
      <li class="page-item" :class="{ disabled: page >= pages || disabled }">
        <a class="page-link" role="button" @click="setPage(page + 1)">&gt;</a>
      </li>
    </ul>
    <p class="VuePagination__count">
      Mostrando {{ from }} de {{ to }} até {{ total }} de registros
    </p>
  </nav>
</template>

<script>
const CHUNK = 10;

export default {
  name: 'SwapPagination',
  props: {
    page: { type: Number, required: true },
    pages: { type: Number, required: true },
    total: { type: Number, required: true },
    perPage: { type: Number, default: 20 },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      windowStart: this.page,
    };
  },
  computed: {
    visiblePages() {
      if (!this.pages) return [];
      const end = Math.min(this.windowStart + CHUNK - 1, this.pages);
      const arr = [];
      for (let i = this.windowStart; i <= end; i++) arr.push(i);
      return arr;
    },
    from() {
      if (!this.total) return 0;
      return (this.page - 1) * this.perPage + 1;
    },
    to() {
      if (!this.total) return 0;
      return this.page === this.pages ? this.total : (this.page - 1) * this.perPage + this.perPage;
    },
  },
  watch: {
    page(val) {
      const inDisplay = val >= this.windowStart && val <= this.windowStart + CHUNK - 1;
      if (!inDisplay) {
        this.windowStart = val === this.pages ? Math.max(1, val - CHUNK + 1) : val;
      }
    },
  },
  methods: {
    setPage(p) {
      if (p < 1 || p > this.pages || p === this.page || this.disabled) return;
      this.$emit('change', p);
    },
  },
};
</script>
